module.exports = __webpack_public_path__ + "media/images/icons/dropdown_arrow-e44c1b5d96ed74411924d54fa1156943.svg";